import {
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from '@griply/types';

export const taskListGroupOptions = [
  GroupByMode.None,
  GroupByMode.Goal,
  GroupByMode.LifeArea,
  GroupByMode.Priority,
  GroupByMode.Type,
  GroupByMode.Deadline,
  GroupByMode.DeadlineDeadline,
  GroupByMode.Tag,
] as const satisfies TaskGroupBy[];

export const taskListSortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.DeadlineDeadline,
  SortingMode.Name,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];

export const goalTaskListGroupOptions = [
  GroupByMode.Section,
  GroupByMode.Goal,
  GroupByMode.Priority,
  GroupByMode.Type,
  GroupByMode.Deadline,
  GroupByMode.DeadlineDeadline,
  GroupByMode.Tag,
] as const satisfies TaskGroupBy[];

export const goalTaskListSortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];

export const taskListFilters = Object.values(FilterOptionKeys).filter(
  (filter) => filter !== FilterOptionKeys.CompletedAt,
) as FilterOptionKeys[];

// Tag-detail is already scoped to one tag, so filtering by Tag there is redundant.
export const tagDetailFilters = taskListFilters.filter(
  (filter) => filter !== FilterOptionKeys.Tag,
);

// Goal- and life-area-detail are scoped to one life area, so filtering by LifeArea is redundant.
export const goalDetailFilters = taskListFilters.filter(
  (filter) => filter !== FilterOptionKeys.LifeArea,
);

export const lifeAreaDetailFilters = taskListFilters.filter(
  (filter) => filter !== FilterOptionKeys.LifeArea,
);
